import constants from '../../config/constants';

const { privileges: PAYMENT_PRIVILEGES } = constants.payment;

// Acciones sobre un pago que exigen `accounting.modify` además de lo que
// diga el backend: cobrar, recuperar, devolver y guardar.
const MODIFY_PRIVILEGES: readonly string[] = [
    PAYMENT_PRIVILEGES.pay,
    PAYMENT_PRIVILEGES.recover,
    PAYMENT_PRIVILEGES.refund,
    PAYMENT_PRIVILEGES.refundTPV,
    PAYMENT_PRIVILEGES.modify,
];

export type PaymentPermissions = {
    /** `accounting.modify` (siempre `true` con los roles apagados). */
    canModify: boolean;
    /** `accounting.delete` (siempre `true` con los roles apagados). */
    canDelete: boolean;
};

/**
 * Recorta los privilegios que el backend da sobre un pago
 * (`payment.privileges`) con los permisos v8 del operador. Nunca añade nada:
 * solo quita lo que el operador no puede hacer.
 */
export function filterPaymentPrivileges(
    privileges: readonly string[] | undefined | null,
    { canModify, canDelete }: PaymentPermissions,
): string[] {
    return (privileges ?? []).filter((privilege) => {
        if (MODIFY_PRIVILEGES.includes(privilege)) return canModify;
        if (privilege === PAYMENT_PRIVILEGES.delete) return canDelete;
        return true;
    });
}
